import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

// height={size}
// width={size}
// {...props}

const IconLeaderboardCuston = ({ size = 24, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="Cup-Star--Streamline-Solar-Ar"
    height={size}
    width={size}
    {...props}
  >
    <desc>Cup Star Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="M12.0002 16c-5.75999 0 -6.78037 -5.7405 -6.96113 -10.29353 -0.05028 -1.26649 -0.07542 -1.89974 0.4003 -2.48564 0.47571 -0.58589 1.04508 -0.68196 2.18381 -0.87409C8.74724 2.15709 10.2166 2 12.0002 2c1.7835 0 3.2529 0.15709 4.3769 0.34674 1.1388 0.19213 1.7081 0.2882 2.1838 0.87409 0.4758 0.5859 0.4506 1.21915 0.4003 2.48564C18.7805 10.2595 17.7601 16 12.0002 16Z"
      stroke="#000000"
      strokeWidth="1.5"
    />
    <path d="M12 16v3" stroke="#000000" strokeLinecap="round" strokeWidth="1.5" />
    <path
      d="M15.5 22h-7l0.33922 -1.6961c0.09349 -0.4674 0.5039 -0.8039 0.98058 -0.8039h4.3604c0.4767 0 0.8871 0.3365 0.9806 0.8039L15.5 22Z"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m19 5 0.9486 0.31621c0.9901 0.33002 1.4851 0.49503 1.7682 0.88787 0.2832 0.39284 0.2832 0.91465 0.2831 1.95826l0 0.07253c0 0.86074 0 1.29111 -0.2072 1.64322 -0.2072 0.35211 -0.5834 0.56111 -1.3358 0.97911L17.5 12.5"
      stroke="#000000"
      strokeWidth="1.5"
    />
    <path
      d="m4.99994 5 -0.94862 0.31621c-0.99006 0.33002 -1.48509 0.49503 -1.76822 0.88787 -0.28314 0.39284 -0.28313 0.91465 -0.2831 1.95826l0 0.07253c0.00003 0.86074 0.00004 1.29111 0.20723 1.64322 0.20718 0.35211 0.5834 0.56111 1.33582 0.97911L6.49994 12.5"
      stroke="#000000"
      strokeWidth="1.5"
    />
    <path
      d="M11.1459 6.02251C11.5259 5.34084 11.7159 5 12 5s0.4741 0.34084 0.8541 1.02251l0.0983 0.17636c0.1079 0.19371 0.1619 0.29057 0.2461 0.35447 0.0842 0.06391 0.189 0.08763 0.3987 0.13507l0.1909 0.0432c0.7379 0.16696 1.1069 0.25044 1.1947 0.53271 0.0878 0.28227 -0.1638 0.5764 -0.6668 1.16466l-0.1302 0.15219c-0.1429 0.16716 -0.2144 0.25074 -0.2466 0.35414 -0.0321 0.10341 -0.0213 0.21492 0.0003 0.43796l0.0197 0.20305c0.076 0.78488 0.1141 1.17728 -0.1157 1.35178 -0.2299 0.1744 -0.5753 0.0154 -1.2662 -0.3027l-0.1787 -0.0823c-0.1964 -0.0904 -0.2945 -0.1356 -0.3986 -0.1356 -0.1041 0 -0.2022 0.0452 -0.3986 0.1356l-0.1787 0.0823c-0.6909 0.3181 -1.0363 0.4771 -1.2662 0.3027 -0.22976 -0.1745 -0.19174 -0.5669 -0.1157 -1.35178l0.0197 -0.20305c0.0216 -0.22304 0.0324 -0.33455 0.0003 -0.43796 -0.0322 -0.1034 -0.10367 -0.18698 -0.24662 -0.35414l-0.13015 -0.15219c-0.50306 -0.58826 -0.75458 -0.88239 -0.6668 -1.16466 0.08778 -0.28227 0.45673 -0.36575 1.19467 -0.53271l0.1909 -0.0432c0.2097 -0.04744 0.3145 -0.07116 0.3987 -0.13507 0.0842 -0.0639 0.1382 -0.16076 0.2461 -0.35447l0.0983 -0.17636Z"
      stroke="#000000"
      strokeWidth="1.5"
    />
    <path d="M18 22H6" stroke="#000000" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);

export default IconLeaderboardCuston;
